import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { logoutAdmin } from '../../firebase/auth';
import './AdminLayout.css';

const NAV_ITEMS = [
  { to: 'dashboard', icon: '📊', label: 'Dashboard' },
  { to: 'add-article', icon: '✏️', label: 'Add Article' },
  { to: 'manage-articles', icon: '📰', label: 'Manage Articles' },
  { to: 'epapers', icon: '📄', label: 'E-Papers' },
  { to: 'advertisements', icon: '📢', label: 'Advertisements' },
  { to: 'categories', icon: '🏷️', label: 'Categories' },
  { to: 'analytics', icon: '📈', label: 'Analytics' },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await logoutAdmin();
      navigate('/admin-secure-login');
    }
  };

  return (
    <div className="admin-layout">
      <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <span>📰</span>
          <div>
            <div className="brand-name-sm">NewsBuzz Today</div>
            <div className="brand-sub">Admin Panel</div>
          </div>
        </div>
        <nav className="sidebar-nav">
          {NAV_ITEMS.map(item => (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}>
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <a href="/" target="_blank" rel="noopener noreferrer" className="view-site-btn">🌐 View Live Site</a>
          <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
        </div>
      </aside>
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <main className="admin-main">
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
